import React from 'react';
import styles from '@/views/Layout/internal/InternalNavBar/index.module.css';
import {
  MainMenuFor,
  MenuFor,
  LabelFor,
  DropdownMainMenu,
} from '@/views/Layout/internal/InternalNavBar/detectMenu';

const CommissionNavContent = () => (
  <div className={styles.megamenu} style={{width: '510px'}}>
    <div className={styles.megamenu_column}>
      <LabelFor name='rateSetup' label='Rate Setup' />
      <ul>
        <li>
          <MenuFor
            name='productRatePayin'
            type='subMenu'
            label='Product Rates (Payin)'
          />
        </li>
        <li>
          <MenuFor
            name='productRatePayout'
            type='subMenu'
            label='Producer Rates (Payout)'
          />
          <MenuFor name='payoutRateImport' type='subMenu' label=' / Import' />
          <MenuFor name='payoutRateHistory' type='subMenu' label=' / History' />
        </li>
        <li>
          <MenuFor name='bvFactor' type='subMenu' label='BV Factor' />
        </li>
        <li>
          <MenuFor name='inHouseRates' type='subMenu' label='In House Rates' />
        </li>
      </ul>
      <br />
      <LabelFor name='posting' label='Posting' />
      <ul>
        <li>
          <MenuFor name='posting' type='subMenu' label='Policy Posting' />
          <MenuFor name='postingHistory' type='subMenu' label=' / History' />
        </li>
      </ul>
    </div>
    <div className={styles.megamenu_column}>
      <LabelFor name='revenueAndSettlement' label='Revenue & Settlement' />
      <ul>
        <li>
          <MenuFor name='revenue' type='subMenu' label='Revenue' />
          <MenuFor name='newRevenue' type='subMenu' label=' / New' />
        </li>
        <li>
          <MenuFor
            name='payinSettlement'
            type='subMenu'
            label='Payin Settlement'
          />
          <MenuFor
            name='payinSettlementImport'
            type='subMenu'
            label=' / Import'
          />
        </li>
        <li>
          <MenuFor
            name='payoutSettlement'
            type='subMenu'
            label='Payout Settlement'
          />
          <MenuFor name='bulkPayoutSettlement' type='subMenu' label=' / Bulk' />
        </li>
      </ul>
      <br />
      <LabelFor name='payment' label='Payment' />
      <ul>
        <li>
          <MenuFor name='holdPaymentList' type='subMenu' label='Hold Payment' />
          <MenuFor name='addHoldPayment' type='subMenu' label=' / Add' />
        </li>
      </ul>
      <br />
      <LabelFor name='statement' label='Statement' />
      <ul>
        <li>
          <MenuFor name='statementList' type='subMenu' label='List' />
          <MenuFor name='statementHistory' type='subMenu' label=' / History' />
        </li>
      </ul>
      <br />
      <LabelFor name='sendingStatement' label='Sending Statement' />
      <ul>
        <li>
          <MenuFor
            name='sendingStatementHistory'
            type='subMenu'
            label='History'
          />
          <MenuFor name='sendingStatement' type='subMenu' label=' / Add' />
        </li>
      </ul>
    </div>
  </div>
);

const CommissionNav = () => (
  <MainMenuFor name='commission'>
    <DropdownMainMenu name='commission' label='Commission'>
      <CommissionNavContent />
    </DropdownMainMenu>
  </MainMenuFor>
);

export default CommissionNav;
